<template>
  <div>
    <Head title="Item Movements" />
    <div class="flex items-center justify-between mb-6">
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-orange-400 hover:text-orange-600" href="/sku-items">
          Items
        </Link>
        <span class="text-orange-400 font-medium">/{{ item.name }}</span>/Movements
      </h1>
      <a
        v-show="item.can_write_off && (user.role === 'admin' ||
          user.per_user_permissions.includes('write_off_uids'))"
        class="btn-orange" href="#" @click="openWriteOffPrompt">
        <span>Write Off</span>
    </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date</th>
          <th class="pb-3 pt-3 px-3">Status</th>
          <th class="pb-3 pt-3 px-3">By</th>
        </tr>
        <tr v-for="(movement, index) in movements" :key="index" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ movement.created_at }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ movement.status }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ movement.user }}
            </span>
          </td>
        </tr>
        <tr v-if="movements.length === 0">
          <td class="px-3 py-3 border-t" colspan="4">No data found</td>
        </tr>
      </table>
    </div>
  </div>
  <div v-if="isWriteOffPrompt" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 20px;">
              Write Off UID
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to write off <strong>{{ item.name }}</strong>, do you wish to
              continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="submit">
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeWriteOffModal">
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Link,
  },
  layout: Layout,
  props: {
    movements: Object,
    item: Object,
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        id: this.item.id,
      }),
      isWriteOffPrompt: false,
    }
  },
  methods: {
    openWriteOffPrompt() {
      this.isWriteOffPrompt = true
    },
    closeWriteOffModal() {
      this.isWriteOffPrompt = false
    },
    submit() {
      this.form.post(`/items/${this.item.id}/movements`, {
        onSuccess: () => {
          this.isWriteOffPrompt = false
        },
      })
    },
  }
}
</script>
